import React from 'react';
import PropTypes from 'prop-types';
import { Button, P, Span } from 'components/Ui';
import { lockIcon } from 'images';
import { GTM_TRACKING_TAGS } from 'utils/constants';
import styles from './styles.scss';

const LockedOut = ({ lockoutName, onOpenPayBill }) => {
  const lockouts = {
    PAST_DUE_ACCOUNT: {
      key: 'LockedOutPastDue',
      value:
        'Your account is past due. Please make a payment immediately to unlock your account.',
    },
    CREDIT_CARD_HOLD: {
      key: 'LockedOutCCHold',
      value:
        'Your credit card payment has been declined. Please add a valid credit card and pay your full balance immediately to resume service.',
    },
    NPSS: {
      key: 'LockedOutNPSS',
      value:
        'You haven’t made a payment on your new account since set-up. Please make a payment to resume service.',
    },
    NSF_HOLD: {
      key: 'LockedOutNSFHOLD',
      value: 'Sorry, your payment has been declined due to insufficient funds.',
    },
  };

  const title = 'Sorry, your account is currently suspended awaiting payment';

  const showUniqueMessage = !!(lockoutName && lockoutName !== 'HL');

  const text = (
    <div>
      {showUniqueMessage && (
        <P translationKey={lockouts[lockoutName].key}>
          {lockouts[lockoutName].value}
        </P>
      )}
      <P translationKey={'LockedOutText1'}>
        You will not be able to order more products or receive delivery until
        your balance is paid in full.
      </P>
      <p>
        <Span translationKey={'LockedOutText2'}>
          Please Note: Payments made through ACH may take up to 7 days to clear
          and credit/debit card payments can take up to 2 days to clear before
          being reflected on your account. If you’ve already mailed your payment
          or have any questions please contact a Customer Service Representative
          at{' '}
        </Span>
        <Span
          className={styles.phoneNumber}
          translationKey={'PhoneNumber:LockoutPayments'}
        >
          866-407-7873
        </Span>
        .
      </p>
      <P>Thank you!</P>
    </div>
  );

  return (
    <div
      className={styles.container}
      data-tracking={GTM_TRACKING_TAGS['Account Suspended']}
    >
      <div className={styles.content}>
        <img src={lockIcon} alt="lockIcon" className={styles.lock} />
        <Span className={styles.title} translationKey={'LockedOutTitle'}>
          {title}
        </Span>
        <span className={styles.text}>{text}</span>
        <Button
          className={styles.btn}
          text="Pay Bill"
          onClick={onOpenPayBill}
        />
      </div>
    </div>
  );
};

LockedOut.propTypes = {
  lockoutName: PropTypes.string.isRequired,
  onOpenPayBill: PropTypes.func.isRequired,
};

export default LockedOut;
